module.exports = {
    "breadcrumbs": `Br\xf8dkrummer`
};


//# sourceMappingURL=da-DK.main.js.map
